import React from 'react';
import { Link } from 'react-router-dom';
import './CustomDashboard.css';

const CustomDashboard = () => {
  return (
    <div className="cd-construction-container">
      <div className="cd-construction-content">
        <div className="cd-construction-icon">
          <i className="fas fa-hard-hat"></i>
        </div>
        <h1 className="cd-construction-title">Dashboard Personalizado</h1>
        <h2 className="cd-construction-subtitle">Em Construção</h2>
        <p className="cd-construction-text">
          Estamos trabalhando em algo incrível para você!
          <br />
          Em breve você poderá criar dashboards personalizados com widgets configuráveis.
        </p>
        <div className="cd-construction-features">
          <div className="cd-feature">
            <i className="fas fa-chart-line"></i>
            <span>Gráficos Interativos</span>
          </div>
          <div className="cd-feature">
            <i className="fas fa-th-large"></i>
            <span>Widgets Arrastáveis</span>
          </div>
          <div className="cd-feature">
            <i className="fas fa-palette"></i>
            <span>Temas Personalizados</span>
          </div>
          <div className="cd-feature">
            <i className="fas fa-save"></i>
            <span>Salvar Configurações</span>
          </div>
        </div>
        <Link to="/dashboard" className="cd-construction-btn">
          <i className="fas fa-arrow-left me-2"></i>
          Voltar ao Dashboard Principal
        </Link>
      </div>
    </div>
  );
};

export default CustomDashboard;
